import * as React from 'react';
import classnames from 'classnames';
import dayOfWeekSlotsSummaryFactory from './DayOfWeekSlotsSummaryFactory';
import TimeSlotsSummary from 'common/entity/components/multiDaySlot/TimeSlotsSummary';

class LocationWorkingSlots extends React.PureComponent {
    render() {
        const { slots, theme, testId } = this.props;
        const wrapperProps = {
            className: theme.dayOfWeekWrap
        };
        if (testId) {
            wrapperProps.testId = testId;
        }
        return (
            <div {...wrapperProps}>
                {slots.map(day => {
                    return (
                        <span
                            className={classnames(theme.dayOfWeek, {
                                [theme.noSlots]: day.slots.size === 0
                            })}
                            key={day.dayOfWeek}
                        >
                            {day.getShortCode()}
                        </span>
                    );
                })}
            </div>
        );
    }
}

const LocationSlotsSummary = dayOfWeekSlotsSummaryFactory({
    TimeSlotsSummary,
    TableSlotSummary: LocationWorkingSlots
});

export default LocationSlotsSummary;
